var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 112 112"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 56,
  r: 53,
  fill: "transparent",
  className: "circle_svg__bg"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 56,
  r: 53,
  fill: "transparent",
  className: "circle_svg__progress"
})));
export default SvgCircle;